<template>
  <div class="question-card">

    <!-- الهيدر -->
    <div class="navbar select">
      <div class="navbar">
        <select v-model.number="selectedIndex" aria-label="اختر سؤالاً">
          <option
            v-for="(q, idx) in questions"
            :key="q.id"
            :value="idx"
          >
            سؤال {{ idx + 1 }} / {{ questions.length }} {{ statuses[idx] }}
          </option>
        </select>
        <div class="timer">
          <span class="timer-icon"></span>
          {{ formattedTime }}
        </div>
      </div>
    </div>

   <!-- نص السؤال -->
    <section class="question-section">
       <!-- نص توجيهي (amr) فوق نص السؤال -->
    <section class="amr-section" v-if="amrText">
      <div class="amr-block">
        <h2
          class="amr-text"
          dir="auto"
          v-html="highlightEnglish(amrText)"
        ></h2>
      </div>
    </section>
    
      <div class="question-block">
        <h2
          id="question"
          class="question-text"
          dir="auto"
          v-html="highlightEnglish(current[`question_${lang}`])"
        ></h2>
       
      </div>
       <button class="block-speak-btn" @click="speak(current[`question_${lang}`])">🔊</button>


      <!-- الإجابات -->
      <div class="answers" dir="ltr">
        <div v-for="(ans, idx) in answerOpts" :key="idx" class="answer-wrapper">
          <button
            :disabled="isAnswered"
            :class="getAnswerClass(idx)"
            @click="selectAnswer(idx)"
            v-html="highlightEnglish(ans)"
          ></button>
          <span class="speak-btn" @click="speak(ans)" title="تشغيل الصوت">🔊</span>
        </div>
      </div>
    </section>

    <!-- شريط التحكم -->
    <div class="footer-controls">
      <button class="control-btn" @click="$emit('prev')" :disabled="currentIndex === 0">⬅️</button>
      <button v-if="hasText" class="control-btn" @click="openText">📄</button>
      <button class="control-btn" @click="$emit('toggle-lang')">🌐</button>
      <button class="control-btn" @click="$emit('next')">
        <span v-if="currentIndex < questions.length - 1">➡️</span>
        <span v-else>🏁</span>
      </button>
    </div>

    <!-- النص المرفق -->
    <div id="text-screen" :class="{ active: showText }" @keydown.esc="closeText" tabindex="0">
      <div class="modal-overlay" @click="closeText"></div>
      <div class="modal-text">
        <div class="modal-header">
          <h3>النص المرفق</h3>
          <button class="modal-back-top" @click="closeText">← رجوع</button>
        </div>
        <div class="attached-body">
          <div class="attached-text" dir="auto">
            <template v-for="(line, idx) in attachedLines" :key="idx">
              <div :class="['line-wrapper', idx % 2 === 0 ? 'en-line' : 'ar-line']">
                <p v-html="highlightEnglish(line)"></p>
                <button v-if="idx % 2 === 0" class="line-speak-btn" @click="speak(line)" title="تشغيل الصوت">🔊</button>
              </div>
            </template>
          </div>
          <button class="modal-back-floating" @click="closeText">← رجوع</button>
        </div>
      </div>
    </div>

    <!-- فقاعة الترجمة -->
    <div v-if="tooltip.show" class="translate-tooltip" :style="{ top: tooltip.y + 'px', left: tooltip.x + 'px' }">
      {{ tooltip.text }}
    </div>

    <!-- تأكيد الخروج -->
    <div v-if="showConfirm" class="confirm-overlay" @click.self="closeConfirm">
      <div class="confirm-dialog">
        <h3>تـأكيـد الخـروج</h3>
        <p>هل تريد فعلاً إلغاء الامتحان؟</p>
        <div class="confirm-actions">
          <button class="btn btn-outline" @click="closeConfirm">أكمل الامتحان</button>
          <button class="btn btn-danger" @click="confirmLeave">إلغاء الامتحان</button>
        </div>
      </div>
    </div>

    <!-- زر عائم للذكاء الصناعي -->
    <button class="floating-ai-btn" @click="openAiHub" aria-label="مركز الذكاء الصناعي">🤖</button>

    <!-- نافذة مركز الذكاء -->
    <div v-if="showAiModal" class="ai-modal-overlay" @click.self="goBack">
      <div class="ai-modal">
        <button class="back-circle-btn" @click="goBack" aria-label="رجوع">← رجوع </button>
        <h3 class="ai-modal-title">✅ تم تجهيز السؤال</h3>
        <p class="copy-status" :class="{ ok: copyOk, warn: !copyOk }">
          <span v-if="copyOk">تم نسخ نص السؤال والأربع خيارات للاجابات تلقائياً. اختر احد ادوات الذكاء الصناعي واضغط لصق داخل مربع الدردشة الخاصة بالذكاء الصناعي.</span>
          <span v-else>تعذر النسخ التلقائي. اضغط “نسخ الآن” ثم الصق داخل مربع الدردشة.</span>
        </p>
        <div class="ai-toolbar">
          <!-- <button class="mini-btn" @click="copyNow">📋 إضغط هنا لنسخ المحتوى </button> -->
          <!-- <button class="mini-btn outline" @click="showPrompt=!showPrompt">{{ showPrompt ? 'إخفاء' : 'عرض' }} المحتوى</button> -->
        </div>
        <div v-if="showPrompt" class="prompt-preview" dir="auto">
          <pre>{{ copiedText }}</pre>
        </div>

        <h4 class="tools-title"> اختر احد ادوات الذكاء الصناعي التالية</h4>
        <div class="ai-tools">
           <button class="tool-btn" @click="openTool('chatgpt')">🧠 ChatGPT</button>
          <button class="tool-btn" @click="openTool('copilot')">🤖 Copilot</button>
          <!-- <button class="tool-btn" @click="openTool('fleo')">✨ Felo AI</button> -->
          <button class="tool-btn" @click="openTool('perplexity')">🔎 Perplexity</button>
          <!-- <button class="tool-btn" @click="openTool('deepseek')">🧬 DeepSeek</button> -->
          <!-- <button class="tool-btn" @click="openTool('deepai')">🌐 DeepAI</button> -->
         <button class="tool-btn" @click="openTool('gemini')"> 🤖 Google Gemini </button>
        </div>

     <p class="proxy-note" dir="rtl">
        ⚠️ قد تحتاج إلى تشغيل <span class="proxy-keyword">البروكسي</span> عند استخدامك لأداة 
        <span class="brand-chatgpt">ChatGPT</span>.
      </p>


      </div>
    </div>

    <!-- Toast -->
    <div id="copy-toast"></div>

  </div>
</template>



<script>
export default {
  name: 'QuestionCard',
  props: {
    questions: { type: Array, required: true },
    current: { type: Object, required: true },
    currentIndex: { type: Number, required: true },
    answered: { type: Object, required: true },
    lang: { type: String, required: true },
    formattedTime: { type: String, required: true }
  },
  data() {
    return {
      showText: false,
      showConfirm: false,
      examFinished: false,
      tooltip: { show: false, text: '', x: 0, y: 0 },
      showAiModal: false,
      copiedText: '',
      copyOk: true,
      showPrompt: false
    };
  },
  computed: {
    answerOpts() {
      return [1, 2, 3, 4].map(i => this.current[`answer${i}_${this.lang}`]);
    },
    attachedText() {
      return (
        this.current[`attached_text_${this.lang}`] ||
        this.current.attached_text ||
        ''
      ).trim();
    },
    hasText() {
      const txt = this.attachedText;
      return txt.length > 0 && !/^[*_]+$/.test(txt);
    },
    attachedLines() {
      return this.attachedText.split('\n').map(l => l.trim()).filter(Boolean);
    },
    isAnswered() {
      return this.answered[this.current.id] !== undefined;
    },
    correctIndex() {
      return this.current.correct_answer - 1;
    },
    statuses() {
      return this.questions.map((q, i) => {
        const ans = this.answered[q.id];
        if (ans == null) return '';
        return ans === this.questions[i].correct_answer - 1 ? '✅' : '❌';
      });
    },
    selectedIndex: {
      get() { return this.currentIndex; },
      set(v) { this.$emit('jump', v); }
    },
    // نص التوجيه amr وفق اللغة الحالية
    amrText() {
      return this.current && (this.current[`amr_${this.lang}`] || '').trim();
    }
  },
  methods: {
    highlightEnglish(text) {
      if (!text) return '';
      return text.replace(/\b[A-Za-z]+\b/g, word =>
        `<span class="clickable-word" data-word="${word}">${word}</span>`
      );
    },

    async handleWordClick(e) {
      if (!e.target.classList.contains("clickable-word")) return;
      const wordEl = e.target;
      const word = wordEl.dataset.word;

      try {
        wordEl.classList.add("clicked-word");
        const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ar&dt=t&q=${encodeURIComponent(word)}`;
        const res = await fetch(url);
        const data = await res.json();
        const translated = data?.[0]?.[0]?.[0] ?? '';

        const rect = wordEl.getBoundingClientRect();
        this.tooltip = {
          show: true,
          text: translated,
          x: rect.left + rect.width / 2,
          y: rect.top + window.scrollY - 40
        };

        this.speak(word);

        setTimeout(() => {
          this.tooltip.show = false;
          wordEl.classList.remove("clicked-word");
        }, 1500);
      } catch (err) {
        console.error("ترجمة فشلت:", err);
      }
    },

    speak(text) {
      if (!text) return;
      const utter = new SpeechSynthesisUtterance(text);
      utter.lang = "en-US";
      utter.rate = 0.6; // أبطأ من الافتراضي
      speechSynthesis.cancel();
      speechSynthesis.speak(utter);
    },

    selectAnswer(idx) { this.$emit('answer', idx); },

    openText() {
      history.pushState({ modalOpen: 'text' }, '', location.href);
      this.showText = true;
    },
    closeText() { this.showText = false; },

    getAnswerClass(idx) {
      if (!this.isAnswered) return '';
      if (idx === this.correctIndex) return 'correct';
      return this.answered[this.current.id] === idx ? 'wrong' : '';
    },

    // ===== مركز الذكاء الصناعي =====
    async openAiHub() {
      // تعديل: نبني نصاً شاملاً ينسخ كل شيء على الشاشة + برومبت فخم
      this.copiedText = this.buildClipboardBlock(); // كان سابقاً buildPrompt()
      this.copyOk = await this.safeCopy(this.copiedText);
      this.showAiModal = true;
      this.showToast(this.copyOk
        ? "✅ تم نسخ السؤال كاملاً مع التوجيه. الصقه داخل دردشة الذكاء الصناعي."
        : "⚠️ تعذر النسخ التلقائي -- استخدم زر نسخ الآن.");
    },

     buildPrompt() {
          const questionText = (this.current[`question_${this.lang}`] || '').trim();
          const answers = this.answerOpts.map((ans) => (ans || '').trim());
          const correctIdxZero = (this.current?.correct_answer ?? 2) - 1; // يسقط إلى (2) إن لم يوجد
          const correctNum = correctIdxZero + 1;
          const correctText = answers[correctIdxZero] || '';

          const optionsBlock = answers
            .map((ans, i) => `${i + 1}️⃣ ${ans}`)
            .join('\n');

          const wrongBlocks = answers
            .map((ans, i) => i + 1)
            .filter((n) => n !== correctNum)
            .map((n) => `- 🔹 **الخيار (${n}):** اشرح بالعربية سبب خطئه بدقة (الزمن/المعنى/المفرد-الجمع/اتفاق الفعل والفاعل/حرف الجر/الترتيب/التصريف) مع مثال توضيحي قصير.`)
            .join('\n');

          return `
        📌 **السؤال:**
        ${questionText}

        🔢 **الخيارات:**
        ${optionsBlock}

        ---

        ✅ **الإجابة الصحيحة: رقم (${correctNum})**
        - 🟦 **نص الإجابة الصحيحة كما هو:** ${correctText}
        - ✨ **تحليل خطوة بخطوة بدقة متناهية:**
          1. **تحديد الزمن/البنية الدقيقة:** حدِّد بوضوح الزمن أو البنية النحوية المستخدمة في الجملة المطلوبة (مضارع بسيط/مستمر، ماضي بسيط/مستمر، حاضر تام/ماضي تام، مستقبل، شرطية، مبني للمجهول، مقارنة/تفضيل...).
          2. **أدلة السياق:** استخرج إشارات الزمن أو المعنى (مثل: always, usually, now, at the moment, yesterday, last, since, for, already, by, if, would, while...) التي تفرض اختيار هذه الصيغة.
          3. **اتفاقات إلزامية:** تأكد من اتفاق الفعل والفاعل، وعدّ المفرد/الجمع، وصيغة الأفعال المساعدة، وحروف الجر الصحيحة، وترتيب الكلمات القياسي.
          4. **تطبيق القاعدة على النص:** اربط الصيغة المختارة بالنص حرفيًا وبيّن لماذا هذا الخيار يطابق القاعدة دون أي التباس.
          5. **حكم نهائي قاطع:** اختم بجملة حاسمة تؤكد الصحة المطلقة لهذا الخيار اعتمادًا على القاعدة والأدلة.

        - 📚 **القاعدة المبسّطة:**
          - **متى نستخدمها:** اذكر الحالات التي تستدعي هذه البنية تحديدًا.
          - **الصيغة القياسية:** اكتب الصيغة العامة بدقة (مثل: Subject + V1، أو am/is/are + V-ing، أو have/has + V3، أو was/were + V-ing...).
          - **مثال واضح:** جملة إنجليزية مشابهة + ترجمة عربية + تعليق قصير يوضّح تطبيق القاعدة.

        ---

        ❌ **لماذا باقي الخيارات خاطئة؟**
        ${wrongBlocks}

        ---

        📝 **أمثلة إضافية مشابهة:**
        1. ✍️ جملة مشابهة (بالإنجليزية) → الترجمة العربية + **تعليق قصير** يبرز نفس القاعدة (اذكر الإشارة الزمنية أو البنية).
        2. ✍️ جملة أخرى (بالإنجليزية) → الترجمة العربية + **تعليق قصير** يوضح الفرق مع خيار خاطئ محتمل ولماذا لا يصلح.

        ---

        🔑 **الخلاصة المركّزة:**
        - **القاعدة الأساسية:** جملة واحدة دقيقة تحدد معيار الاختيار (إشارة زمنية محددة، معنى الاستمرارية/الاكتمال، شرطية، مبني للمجهول...).
        - **نقطة الحفظ:** صيغة مختصرة أو كلمة مفتاحية تتكرر في ذهن الطالب لتثبيت القاعدة ✨

        🧭 **تعليمات التنفيذ الصارمة:**
        - **اللغة:** استخدم العربية حصريًا وبأسلوب واضح واحترافي.
        - **الدقة:** اعتمد التحليل البنيوي والسياقي وخطّط الخطأ لكل خيار غير صحيح.
        - **القطع:** اذكر رقم الإجابة ونصها كما هو واستخدم أدلة نصية صريحة لضمان الاختيار بنسبة 100%.
        `.trim();
        }

        ,

    // ===== إضافة برومبت فخم ومحسّن للاستخدام مع Gemini أو غيره =====
    buildPromptEnhanced() {
      const qAr = (this.current?.question_ar || '').trim();
      const qEn = (this.current?.question_en || '').trim();
      const answersAr = [1,2,3,4].map(i => (this.current?.[`answer${i}_ar`] || '').trim());
      const answersEn = [1,2,3,4].map(i => (this.current?.[`answer${i}_en`] || '').trim());
      const attachedAr = (this.current?.attached_text_ar || '').trim();
      const attachedEn = (this.current?.attached_text || '').trim();
      const amrAr = (this.current?.amr_ar || '').trim();
      const amrEn = (this.current?.amr_en || '').trim();

      const optionsPretty = [0,1,2,3].map(i => {
        const la = answersAr[i] || '';
        const le = answersEn[i] || '';
        return `${i+1}️⃣ ${la}${le ? `  |  ${le}` : ''}`;
      }).join('\n');

      const extras = []
        .concat(attachedAr ? [`📎 نص مرفق (عربي):\n${attachedAr}`] : [])
        .concat(attachedEn ? [`📎 Attached (EN):\n${attachedEn}`] : [])
        .concat(amrAr ? [`🧭 أمر (AR): ${amrAr}`] : [])
        .concat(amrEn ? [`🧭 Command (EN): ${amrEn}`] : [])
        .join('\n\n');

      return `
🎯 تعليمات مختصرة للذكاء:
- فكر بعمق وبمنهجية، واجب باحترافية عالية.
- اذكر نص السؤال والخيارات الأربعة بالنصين (إن توفّر)، مع ترجمة عربية للإنجليزي.
- اختر المطلوب بدقة مطلقة حسب الأمر (اختيار الإجابة الصحيحة/الخاطئة/الجملة الصحيحة/الخاطئة/السؤال الصحيح/السؤال الخاطئ).
- بعد الاختيار، اذكر رقم الخيار ونصه كما هو.
- فسّر سبب صحة الخيار الفائز، واشرح القاعدة النحوية بأسلوب مبسّط يفهمه المبتدئ.
- حلّل كل خيار خاطئ على حدة وبيّن موطن الخطأ (زمن/معنى/اتفاق/ترتيب/تصريف/حرف جر...) مع مثال قصير.
- اجعل الإخراج منسقًا وفخمًا وملائمًا للنشر على قناة تلغرام التعليمية مع الإيموجي والتقسيمات الواضحة.

📌 السؤال:
${qAr || '(بدون نص عربي)'}
${qEn ? `\nEN: ${qEn}` : ''}

🔢 الخيارات:
${optionsPretty}

${extras ? `\n${extras}\n` : ''}

🧪 المخرجات المطلوبة (نسق تلغرام فخم):
1) 🗂️ العنوان: نوع المطلوب (مثلاً: اختر الإجابة الصحيحة).
2) ❓ نص السؤال (AR + EN).
3) 🔢 الخيارات (1→4) مع الترجمة.
4) ✅ الإجابة المختارة: رقم (..)، والنص كما هو.
5) 🔍 التحليل العميق خطوة بخطوة:
   - تحديد الزمن/البنية، أدلة السياق، الاتفاقات، التطبيق على النص، حكم نهائي.
6) 📚 القاعدة المبسّطة:
   - متى نستخدمها، الصيغة القياسية، مثال واضح (EN + ترجمة).
7) ❌ لماذا باقي الخيارات خاطئة؟
   - خيار (1): السبب + مثال.
   - خيار (2): السبب + مثال.
   - خيار (3): السبب + مثال.
   - خيار (4): السبب + مثال.
8) 📝 أمثلة إضافية مشابهة (2 أمثلة قصيرة).
9) 🔑 الخلاصة المركزة: قاعدة أساسية + نقطة حفظ مختصرة.

⛔ الدقة: تأكد من الاختيار بنسبة 100% قبل الإجابة، واعتمد على أدلة نصية صريحة.
`.trim();
    },

    // كتلة شاملة تُنسخ للحافظة: كل ما على الشاشة + برومبت الذكاء
    buildClipboardBlock() {
      const questionTextAR = (this.current?.question_ar || '').trim();
      const questionTextEN = (this.current?.question_en || '').trim();
      const answersAR = [1,2,3,4].map(i => (this.current?.[`answer${i}_ar`] || '').trim());
      const answersEN = [1,2,3,4].map(i => (this.current?.[`answer${i}_en`] || '').trim());
      const attachedAR = (this.current?.attached_text_ar || '').trim();
      const attachedEN = (this.current?.attached_text || '').trim();
      const amrAR = (this.current?.amr_ar || '').trim();
      const amrEN = (this.current?.amr_en || '').trim();

      const optionsLines = [0,1,2,3].map(i => {
        const ar = answersAR[i] || '';
        const en = answersEN[i] || '';
        return `${i+1}) ${ar}${en ? `  |  ${en}` : ''}`;
      }).join('\n');

      const header = `🧠 أمر: اختر الإجابة الصحيحة بدقة متناهية بعد تفكير عميق، واذكر نص السؤال والخيارات الأربع مع ترجمتها، ثم حلّل وعلّل وفسّر القاعدة للمبتدئ، وأخرج النتيجة بأسلوب فخم مناسب لتلغرام.`;
      const promptEnhanced = this.buildPromptEnhanced();

      return [
        header,
        '',
        '❓ السؤال (AR):',
        questionTextAR || '(لا يوجد)',
        questionTextEN ? `EN: ${questionTextEN}` : '',
        '',
        '🔢 الخيارات:',
        optionsLines,
        '',
        attachedAR ? `📎 نص مرفق (AR):\n${attachedAR}` : '',
        attachedEN ? `📎 Attached (EN):\n${attachedEN}` : '',
        amrAR ? `🧭 أمر (AR): ${amrAR}` : '',
        amrEN ? `🧭 Command (EN): ${amrEN}` : '',
        '',
        '———— برومبت موجّه للذكاء ————',
        promptEnhanced
      ].filter(Boolean).join('\n');
    },

    async safeCopy(text) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {
        try {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          const ok = document.execCommand('copy');
          document.body.removeChild(ta);
          return ok;
        } catch {
          return false;
        }
      }
    },

    async copyNow() {
      const ok = await this.safeCopy(this.copiedText);
      this.copyOk = ok;
      this.showToast(ok
        ? "✅ تم نسخ نص السؤال والأجوبة."
        : "❌ تعذر النسخ");
    },

    goBack() { this.showAiModal = false; },

  openTool(which) {
  const encoded = encodeURIComponent(this.copiedText);
  const urls = {
    copilot: 'https://copilot.microsoft.com',
    fleo: 'https://felo.ai/search',
    chatgpt: 'https://chatgpt.com',
    perplexity: `https://www.perplexity.ai/?q=${encoded}`,
    deepseek: 'https://chat.deepseek.com',
  
    deepai: 'https://deepai.org/chat',
    z: 'https://chat.z.ai/',
    // ===== تمت إضافة Gemini مع تمرير النص عبر q عندما يكون مدعوماً =====
    gemini: `https://gemini.google.com/app?hl=ar&q=${encoded}`
  };
  // الافتراضي الآن Copilot أولاً، ثم Felo، ثم ChatGPT
  const url = urls[which] || urls.copilot || urls.fleo || urls.chatgpt;
  window.open(url, '_blank', 'noopener');
  setTimeout(() => { this.showAiModal = false; }, 1500);
}

,


    showToast(message) {
      const toast = document.getElementById('copy-toast');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('show');
      setTimeout(() => toast.classList.remove('show'), 2200);
    },

    // ===== تأكيد الخروج =====
   handlePopState() {
  if (this.showText || !this.examFinished) {
    this.showConfirm = true;
    // نرجع مباشرة pushState حتى لا يخرج المستخدم
    history.pushState({ inQuiz: true }, '', location.href);
  }
}
,

  closeConfirm() {
    this.showConfirm = false;
  },

 confirmLeave() {
  if (this.showText) {
    this.showText = false;
    this.closeConfirm();
    return;
  }
  if (!this.examFinished) {
    // لا ننهي الامتحان مباشرة، فقط نغلق النافذة
    this.closeConfirm();
    // نضيف pushState جديد حتى يبقى التحذير يعمل كل مرة
    history.pushState({ inQuiz: true }, '', location.href);
    return;
  }
  // إذا الامتحان منتهي بالفعل → اسمح بالخروج
  this.$emit('exam-finished');
  this.closeConfirm();
  history.back();
},



    onBeforeUnload(event) {
      if (!this.examFinished) {
        event.preventDefault();
        event.returnValue = '';
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleWordClick);
    window.addEventListener('popstate', this.handlePopState);
    window.addEventListener('beforeunload', this.onBeforeUnload);
    // إضافة حالة تاريخية حتى يلتقط زر الرجوع
  history.replaceState({ inQuiz: true }, '', location.href);
  history.pushState({ inQuiz: true }, '', location.href);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleWordClick);
    window.removeEventListener('popstate', this.handlePopState);
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  }
};
</script>


<style>
/* =========================================
   Fluent-inspired + Apple-inspired Touches (RTL-first)
   ========================================= */

/* متغيرات عامة للألوان والمسافات */
:root {
  --primary: #2563eb;            /* Fluent blue */
  --primary-600: #1e4fd7;
  --primary-50: #eef2ff;

  --accent: #d4af37;             /* لمسة ذهبية رصينة */
  --success: #16a34a;
  --danger: #dc2626;

  --bg: #0b1220;                 /* خلفية داكنة مزرّقة مريحة */
  --surface: #0f172a;            /* طبقة سفلية للعناصر */
  --elevated: #111827;           /* طبقة مرتفعة */
  --card: #ffffff;               /* بطاقات/حوار فاتح */
  --text: #111827;               /* نص داكن على الأبيض */
  --muted: #6b7280;              /* ثانوي */
  --divider: rgba(0,0,0,0.08);   /* حدود خفيفة */
  --shadow: 0 8px 24px rgba(0,0,0,0.12);

  --radius: 12px;
  --radius-lg: 16px;
  --focus: 0 0 0 3px rgba(37,99,235,0.25);

  --hover: rgba(0,0,0,0.04);

  /* لمسات Apple إضافية */
  --apple-glass: rgba(255, 255, 255, 0.06);
  --apple-glass-strong: rgba(255, 255, 255, 0.12);
  --apple-stroke: rgba(255, 255, 255, 0.14);
  --apple-stroke-dark: rgba(0, 0, 0, 0.18);
  --apple-shadow-soft: 0 2px 8px rgba(0,0,0,0.18);
  --apple-shadow-ultra: 0 20px 60px rgba(0,0,0,0.35);
  --apple-blue: #0a84ff; /* iOS blue */
  --apple-blue-600: #0066cc;
  --apple-bg-deep: #0a0f1a;
}

/* تحسين الخطوط والاتجاه */
html, body {
  margin: 0;
  padding: 0;
  background: radial-gradient(1200px 800px at 20% 10%, rgba(255,255,255,0.04), transparent 60%),
              radial-gradient(900px 700px at 80% 0%, rgba(255,255,255,0.03), transparent 55%),
              var(--bg);
  color: #e5e7eb;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Cairo", "Segoe UI", "Inter", system-ui, -apple-system, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: -0.01em; /* نعومة Apple */
}

/* نصوص عربية/إنجليزية */
.question-text,
.attached-text p.ar-line {
  font-family: "Cairo", -apple-system, "SF Pro Text", sans-serif;
  direction: rtl;
  text-align: right;
  line-height: 1.9; /* زيادة طفيفة لراحة القراءة */
  white-space: pre-wrap;
  word-break: keep-all;
  margin-bottom: 6px;
  color: #eaeef5;
}

.attached-text p.en-line {
  direction: ltr;
  text-align: left;
  font-family: -apple-system, "SF Pro Text", "Segoe UI", "Inter", Arial, sans-serif;
  line-height: 1.7;
  color: #e5e7eb;
}

/* كلمات قابلة للنقر للترجمة */
.clickable-word {
  cursor: pointer;
  background: rgba(10, 132, 255, 0.14); /* Apple blue tint */
  border-radius: 9px;
  padding: 0 6px;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  border: 0.5px solid rgba(255,255,255,0.06);
  backdrop-filter: saturate(120%) blur(6px);
}
.clickable-word:hover {
  background: rgba(10, 132, 255, 0.24);
  color: #ffffff;
  transform: translateY(-0.5px);
  box-shadow: 0 4px 10px rgba(10,132,255,0.15);
}
.clickable-word.clicked {
  background: linear-gradient(180deg, var(--apple-blue), var(--apple-blue-600));
  color: #fff;
  box-shadow: 0 6px 14px rgba(10,132,255,0.28);
  border-color: rgba(255,255,255,0.12);
}

/* لون مميز للكلمة عند النقر (fallback) */
.clicked-word {
  background-color: var(--apple-blue);
  color: #fff;
  border-radius: 8px;
  padding: 0 5px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

/* فقاعة الترجمة (Tooltip) */
.translate-tooltip {
  position: absolute;
  background: linear-gradient(180deg, rgba(18,18,20,0.95), rgba(8,8,10,0.95));
  color: #f3f4f6;
  padding: 10px 12px;
  border-radius: 12px;
  border: 0.5px solid var(--apple-stroke);
  box-shadow: var(--apple-shadow-soft);
  font-size: 14px;
  white-space: nowrap;
  z-index: 10000;
  transform: translateX(-50%);
  backdrop-filter: saturate(120%) blur(12px);
}

/* شاشة تأكيد الخروج */
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,0.55);
  backdrop-filter: blur(10px) saturate(110%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}
.confirm-dialog {
  background: linear-gradient(180deg, rgba(255,255,255,0.86), rgba(255,255,255,0.92));
  border-radius: 20px; /* Apple roundness */
  padding: 1.25rem;
  width: min(92vw, 380px);
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
  border: 0.5px solid rgba(0,0,0,0.08);
  color: #0b1220;
  backdrop-filter: blur(14px) saturate(140%);
}
.confirm-dialog h3 {
  margin: 0 0 0.6rem;
  font-family: -apple-system, "SF Pro Display", "Cairo", sans-serif;
  color: #0b1220;
  font-weight: 800;
  font-size: 1.15rem;
  letter-spacing: -0.01em;
}
.confirm-dialog p {
  font-family: -apple-system, "SF Pro Text", "Cairo", sans-serif;
  margin: 0 0 1rem;
  color: #374151;
}
.confirm-actions {
  display: flex;
  gap: 0.6rem;
}
.confirm-actions .btn {
  flex: 1;
  padding: 0.7rem;
  border-radius: 12px;
  font-weight: 800;
  cursor: pointer;
  border: 0.5px solid rgba(0,0,0,0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  letter-spacing: -0.01em;
}
.confirm-actions .btn:focus-visible { outline: none; box-shadow: 0 0 0 4px rgba(10,132,255,0.25); }
.btn-outline {
  background: #ffffff;
  border: 0.5px solid rgba(0,0,0,0.12);
  color: var(--apple-blue);
}
.btn-outline:hover { background: #f7f7f8; transform: translateY(-1px); }
.btn-danger {
  background: linear-gradient(180deg, #ff453a, #d70015);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 6px 16px rgba(255,69,58,0.28);
}
.btn-danger:hover { filter: brightness(1.05); transform: translateY(-1px); }

/* Toast النسخ */
#copy-toast {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(20, 20, 22, 0.92);
  color: #fff;
  font-size: 14px;
  padding: 10px 14px;
  border-radius: 14px;
  border: 0.5px solid rgba(255,255,255,0.12);
  box-shadow: 0 14px 44px rgba(0,0,0,0.35);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.25s ease;
  z-index: 9999;
  max-width: 90%;
  text-align: center;
  backdrop-filter: blur(10px) saturate(120%);
}

/* زر الذكاء الصناعي العائم (ستايل مايكروسوفت فخم) + لمسة Apple */
.floating-ai-btn {
  position: fixed;
  bottom: 4rem;
  right: 1rem;
  width: 64px;
  height: 64px;
  background: radial-gradient(120% 140% at 30% 20%, rgba(255,255,255,0.18), transparent 60%),
              linear-gradient(135deg, var(--apple-blue), #1e3a8a);
  color: #fff;
  font-size: 1.6rem;
  font-weight: 800;
  border: none;
  border-radius: 20px; /* أكثر مربّعية كأزرار iOS الحديثة */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1500;

  /* ظل ولمعة */
  box-shadow:
    0 8px 24px rgba(10,132,255,0.35),
    inset 0 0 0 0.5px rgba(255,255,255,0.25);

  /* حركة سلسة */
  transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease, border-radius 0.25s ease;

  /* نبض خفيف */
  animation: pulseGlow 2.6s infinite ease-in-out;
}

.floating-ai-btn:hover {
  transform: translateY(-4px) scale(1.05);
  filter: saturate(110%);
  box-shadow:
    0 12px 30px rgba(10,132,255,0.45),
    inset 0 0 0 0.5px rgba(255,255,255,0.35);
  border-radius: 22px;
}

/* التسمية المنبثقة */
.floating-ai-btn::after {
  content: "الذكاء الصناعي";
  position: absolute;
  bottom: calc(100% + 10px);
  right: 50%;
  transform: translateX(50%);
  background: rgba(20,20,22,0.9);
  color: #f9fafb;
  padding: 6px 12px;
  font-size: 0.82rem;
  font-weight: 700;
  border-radius: 10px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.25s ease;
  box-shadow: 0 4px 18px rgba(0,0,0,0.35);
  border: 0.5px solid rgba(255,255,255,0.12);
  backdrop-filter: blur(8px);
}

.floating-ai-btn:hover::after {
  opacity: 1;
  transform: translateX(50%) translateY(-4px);
}

/* حركة نبضية */
@keyframes pulseGlow {
  0%, 100% {
    box-shadow:
      0 8px 24px rgba(10,132,255,0.35),
      inset 0 0 0 0.5px rgba(255,255,255,0.25);
  }
  50% {
    box-shadow:
      0 12px 32px rgba(10,132,255,0.5),
      inset 0 0 0 0.7px rgba(255,255,255,0.35);
  }
}

/* نافذة AI */
.ai-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 12px;
  backdrop-filter: blur(10px) saturate(110%);
}
.ai-modal {
  position: relative;
  background: linear-gradient(180deg, rgba(13,17,23,0.9), rgba(6,8,12,0.92));
  border: 0.5px solid rgba(255,255,255,0.09);
  border-radius: 22px;
  padding: 16px;
  width: min(92vw, 760px);
  box-shadow: var(--apple-shadow-ultra);
  color: #e5e7eb;
  backdrop-filter: blur(12px) saturate(140%);
}
/* زر الرجوع (دائري نابض أعلى يسار الشاشة) */
.back-circle-btn {
  position: fixed;
  top: 1.5rem;   /* أعلى الشاشة */
  left: 1.5rem;  /* يسار الشاشة */
  width: 60px;
  height: 60px;
  border-radius: 50%; /* دائري بالكامل */
  border: none;
  background: linear-gradient(135deg, #2563eb, #1e40af); /* أزرق هادئ */
  color: #fff;
  font-size: 20px; /* حجم النص أو الأيقونة */
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;

  box-shadow:
    0 8px 22px rgba(37,99,235,0.35),
    inset 0 0 0 1px rgba(255,255,255,0.25);

  transition: transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;

  animation: pulseBtn 1.8s infinite ease-in-out; /* حركة النبض */
}

.back-circle-btn:hover {
  transform: scale(1.15); /* تكبير عند التحويم */
  background: linear-gradient(135deg, #1d4ed8, #1e40af);
  box-shadow:
    0 12px 28px rgba(37,99,235,0.45),
    inset 0 0 0 1px rgba(255,255,255,0.35);
}

.back-circle-btn:active {
  transform: scale(0.95);
  background: linear-gradient(135deg, #1e40af, #1d4ed8);
  box-shadow: inset 0 6px 14px rgba(0,0,0,0.35);
}

/* حركة النبض */
@keyframes pulseBtn {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37,99,235,0.5); }
  50% { transform: scale(1.08); box-shadow: 0 0 0 14px rgba(37,99,235,0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37,99,235,0); }
}

/* حركة النبض */
@keyframes pulseBtn {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37,99,235,0.5); }
  50% { transform: scale(1.08); box-shadow: 0 0 0 12px rgba(37,99,235,0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(37,99,235,0); }
}


/* حركة النبض */
@keyframes pulseBtn {
  0%, 100% {
    box-shadow:
      0 8px 22px rgba(10,132,255,0.35),
      inset 0 0 0 0.5px rgba(255,255,255,0.25);
  }
  50% {
    box-shadow:
      0 12px 30px rgba(10,132,255,0.5),
      inset 0 0 0 0.7px rgba(255,255,255,0.35);
  }
}

.ai-modal-title {
  font-weight: 900;
  font-size: 1.3rem;
  color: #f3f4f6;
  text-align: center;
  margin-bottom: 10px;
  letter-spacing: -0.01em;
}

/* حالات النسخ */
.copy-status {
  text-align: center;
  font-weight: 800;
  margin-bottom: 8px;
  letter-spacing: -0.01em;
}
.copy-status.ok { color: #34c759; }     /* Apple green */
.copy-status.warn { color: #ffd60a; }   /* Apple yellow */

/* شريط أدوات */
.ai-toolbar {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.mini-btn {
  padding: 10px 14px;
  border-radius: 12px;
  border: 0.5px solid rgba(255,255,255,0.1);
  background: rgba(31,41,55,0.75);
  color: #e5e7eb;
  cursor: pointer;
  font-weight: 800;
  transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.15s ease, border-color 0.2s ease;
  backdrop-filter: blur(8px) saturate(120%);
  letter-spacing: -0.01em;
}
.mini-btn:hover { background: rgba(17,24,39,0.85); transform: translateY(-1px); box-shadow: 0 8px 18px rgba(0,0,0,0.25); }
.mini-btn:focus-visible { outline: none; box-shadow: 0 0 0 4px rgba(10,132,255,0.25); }
.mini-btn.outline {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(10,132,255,0.45);
  color: #dbeafe;
}
.mini-btn.ghost {
  background: rgba(255,255,255,0.02);
  border: 1px dashed rgba(255,255,255,0.2);
  color: #e5e7eb;
}

/* تلميح اللصق */
.paste-hint {
  background: rgba(11,19,32,0.85);
  border: 0.5px solid rgba(255,255,255,0.08);
  color: #e5e7eb;
  padding: 10px 12px;
  border-radius: 12px;
  margin: 6px auto 12px;
  max-width: 95%;
  text-align: center;
  font-size: 13px;
  backdrop-filter: blur(8px) saturate(120%);
}

/* معاينة النص */
.prompt-preview {
  background: rgba(11,15,25,0.85);
  border: 0.5px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  padding: 12px;
  max-height: 32vh;
  overflow: auto;
  margin-bottom: 10px;
  backdrop-filter: blur(8px) saturate(120%);
}
.prompt-preview pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  color: #e5e7eb;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  line-height: 1.65;
}

/* عنوان الأدوات بلمسة ذهبية خفيفة */
.tools-title {
  text-align: center;
  margin: 6px 0 10px;
  font-weight: 900;
  font-size: 1.35rem;
  color: #f3f4f6;
  letter-spacing: -0.01em;
}

/* شبكة الأدوات */
.ai-tools {
  display: grid;
  grid-template-columns: repeat(2, minmax(0,1fr));
  gap: 10px;
}
.tool-btn {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-radius: 16px;
  border: 0.5px solid rgba(255,255,255,0.08);
  background: rgba(15,23,42,0.75);
  color: #e5e7eb;
  cursor: pointer;
  text-align: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease, border-color 0.2s ease;
  backdrop-filter: blur(10px) saturate(120%);
}
.tool-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(0,0,0,0.28);
  background: rgba(17,24,39,0.85);
  border-color: rgba(255,255,255,0.14);
}
.tool-ico { font-size: 22px; }
.tool-name { font-weight: 900; letter-spacing: .1px; }
.tool-btn small { opacity: .85; font-size: 12px; }

.tool-btn.copilot { border-color: rgba(37, 99, 235, .35); }
.tool-btn.perplexity { border-color: rgba(16, 185, 129, .35); }
.tool-btn.deepseek { border-color: rgba(99,102,241,.35); position: relative; overflow: hidden; }
.tool-btn.poe { border-color: rgba(147, 51, 234, .35); }
.tool-btn.openrouter { border-color: rgba(14, 165, 233, .35); }
.ds-logo {
  width: 18px; height: 18px; display: inline-block;
  background: conic-gradient(from 180deg, #38bdf8, #22d3ee, #34d399, #60a5fa, #38bdf8);
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.18);
}

/* أزرار الإجابات */
.answers {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  direction: rtl;
  padding: 1rem;
}
.answers button {
  width: auto;
  max-width: 100%;
  padding: 12px 16px;
  background: rgba(15,23,42,0.75);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px;
  color: #e5e7eb;
  font-size: 16px;
  font-weight: 800;
  font-family: -apple-system, "SF Pro Text", "Segoe UI", Arial, sans-serif;

  direction: ltr;
  unicode-bidi: plaintext;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  text-align: left;
  line-height: 1.6;
  word-spacing: 0.2em;

  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
  backdrop-filter: blur(8px) saturate(120%);
}
.answers button:hover {
  transform: translateY(-1px);
  background: rgba(17,24,39,0.85);
  border-color: rgba(10,132,255,0.35);
  box-shadow: 0 10px 22px rgba(0,0,0,0.28);
}
.answers button.correct {
  background: linear-gradient(180deg, #34c759, #248a3d) !important;
  border-color: transparent !important;
  color: #fff !important;
  box-shadow: 0 10px 24px rgba(52,199,89,0.28) !important;
}
.answers button.wrong {
  background: linear-gradient(180deg, #ff453a, #d70015) !important;
  border-color: transparent !important;
  color: #fff !important;
  box-shadow: 0 10px 24px rgba(255,69,58,0.28) !important;
}

/* شاشة النص المرفق */
#text-screen {
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,0.55);
  z-index: 1150;
  display: none;
  backdrop-filter: blur(8px);
}
#text-screen.active { display: block; }
.modal-overlay { position: absolute; inset: 0; }
.modal-text {
  position: absolute;
  inset: auto 0 0 0;
  margin: auto;
  width: min(92vw, 780px);
  max-height: 80vh;
  background: linear-gradient(180deg, rgba(255,255,255,0.86), rgba(255,255,255,0.92));
  border-radius: 18px 18px 0 0;
  padding: 16px;
  overflow: hidden;
  box-shadow: 0 -10px 40px rgba(0,0,0,0.2);
  border: 0.5px solid rgba(0,0,0,0.08);
  color: var(--text);
  backdrop-filter: blur(14px) saturate(140%);
}
.modal-header {
  display: flex; align-items: center; justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.attached-body {
  margin-top: 8px; overflow: auto; max-height: calc(80vh - 64px);
}

/* زر الرجوع أعلى المودال */
.modal-back-top {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  font-size: 0.98rem;
  font-weight: 900;
  color: var(--apple-blue);
  background: #ffffff;
  border: 1px solid rgba(10,132,255,0.35);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  letter-spacing: -0.01em;
}
.modal-back-top:hover {
  background: #f7f7f8;
  color: #0066cc;
  transform: translateY(-1px);
}
.modal-back-top:active {
  transform: translateY(0);
}

/* قسم amr (التوجيه) بأسلوب كبسولة Fluent + Apple */
.amr-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px auto;
  padding: 8px 16px;
  background: rgba(15,23,42,0.75);
  border: 0.5px solid rgba(255,255,255,0.1);
  border-radius: 999px;
  max-width: max-content;
  box-shadow: 0 6px 18px rgba(0,0,0,0.18);
  backdrop-filter: blur(10px) saturate(120%);
}
.amr-text {
  font-family: "Cairo", -apple-system, "SF Pro Text", sans-serif;
  font-size: 1.02rem;
  font-weight: 900;
  color: #e5e7eb;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.01em;
}

.proxy-note {
  margin: 1.2rem auto;
  padding: 0.9rem 1.2rem;
  max-width: 600px;
  text-align: center;
  font-size: 1.05rem;
  font-weight: 800;
  color: #f7f7f7;
  background: rgba(255, 215, 0, 0.08);
  border: 1px solid rgba(255, 215, 0, 0.35);
  border-radius: 14px;
  line-height: 1.6;
  box-shadow: 0 0 15px rgba(255,215,0,0.15);
  font-family: 'Tajawal', -apple-system, sans-serif;
  direction: rtl;
}

.proxy-keyword {
  color: #ffd700;
  font-weight: 900;
}

.brand-chatgpt {
  color: #00a67d;
  font-weight: 900;
  text-shadow: 0 0 8px rgba(0, 166, 125, 0.6);
}

/* تحسينات وصول */
:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(10,132,255,0.25);
  border-radius: 10px;
}

/* وسائل عرض ضيقة */
@media (max-width: 480px) {
  .ai-tools { grid-template-columns: 1fr; }
  .floating-ai-btn { right: 0.75rem; bottom: 3.25rem; }
  .prompt-preview { max-height: 28vh; }
}
</style>
